export const CLEAR_CART = 'CLEAR_CART'
export const REMOVE = 'REMOVE'
export const UPDATE = "UPDATE"
export const GET_TOTAL = "GET_TOTAL"

export const SET_CART = "SET_CART"
export const ADD_ITEM = "ADD_ITEM"

